/** Мок API: шаринг. */
import type { FakeDb, FakeHandlers } from "./db";

export function shareHandlers(_db: FakeDb): FakeHandlers<"share"> {
  return {
    share: async (req) => ({
      preparedMessageId: req.target === "chat" ? "fake-prepared" : null,
      imageUrl: "https://newfungame.com/share/fake.png",
      startParam: "fake",
    }),
  };
}
